.a0{flex-direction:row;}